export default __webpack_public_path__ + "static-bigflip/media/icon-step-1.07748e58.png";